var imat = imat || {};

imat.cookieOverlay = function () {
    var _view;

    var view = function () {
        var siteMessageBarSelector = $("#cookieOverlayBar");
        var closeButtonSelector = $("#closeCookieOverlayBar");

        var messagePresent = function() {
            return siteMessageBarSelector.length > 0;
        }

        var hideMessage = function () {
            if (messagePresent()) {
                siteMessageBarSelector.hide();
            }
        }

        var setCloseButtonHandler = function (clickHandler) {
            if (!clickHandler) {
                throw "clickHandler should be defined";
            }

            if (typeof (clickHandler) !== 'function') {
                throw "clickHandler should be a function";
            }

            closeButtonSelector.bind('click', clickHandler);
        };

        return {
            hideMessage: hideMessage,
            messagePresent: messagePresent,
            setCloseButtonHandler: setCloseButtonHandler
        };
    }

    var disableMessage = function () {
        _view.hideMessage();
        var data = {};

        $.ajax({
            type: "POST",
            async: true,
            url: "/Content/DisableCookieMessage",
            data: data
        });
    }

    var init = function () {
        _view = view();

        if (!navigator.cookieEnabled) {
            _view.hideMessage();
        }
        else
        if (_view.messagePresent()) {
            _view.setCloseButtonHandler(disableMessage);
        }
    };

    return {
        init: init
    };
}();


$(document).ready(function () {
    imat.cookieOverlay.init();
});